import {
  ExperimentClient,
  ExperimentInfo,
  ISOWellDropScoreDTO,
  SaveNonPersistedExpDTO,
  ScreenExperimentTemplateDTO,
  ScreenExpWizardClient,
  SaveScreenExpTemplateDTO,
  ExperimentDTO,
  PlateClient,
  TreeClient,
  LayerDTO,
} from 'business/models/Models';
import { isNullOrUndefined, history } from 'utils/Global';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from 'business/services/BaseService';
import { CacheHelper } from 'utils/CacheHelper';

export default class WizardService extends BaseService {
  async getWizardScreens(id, plateTypeId = 3) {
    const service: TreeClient = ModelFactory(TreeClient);
    if (id == null) {
      id = -1;
    }
    const userToken = await CacheHelper.get('token');
    if (isNullOrUndefined(userToken)) {
      history.push('/login');
      return null;
    }
    const root = await service.getWizardScreensByParentId(id, plateTypeId);

    return root;
  }

  async getWizardProteins(id, plateTypeId, includePath = false) {
    if (id == null) {
      id = -1;
    }
    const userToken = await CacheHelper.get('token');
    if (isNullOrUndefined(userToken)) {
      history.push('/login');
      return null;
    }
    const service: TreeClient = ModelFactory(TreeClient, false, true);

    const root = await service.getWizardProteinsByParentId(id, plateTypeId, includePath);

    return root;
  }

  async getWizardFragments(id = -1) {
    const service: TreeClient = ModelFactory(TreeClient, false, true);
    const root = await service.getWizardFragmentsByParentId(id);
    return root;
  }

  async getPlateTypes() {
    const plate: PlateClient = ModelFactory(PlateClient);
    const platetypes = await plate.getPlateTypesForWizard();
    return platetypes;
  }

  async getExpWizardTemplate(templatename: string) {
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    return await expWizTemplate.getScreenExperimentTemplateData(templatename);
  }
  async getTemplateNames() {
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    return await expWizTemplate.getScreenExperimentTemplateNames();
  }

  async saveScreenExpTemplateByFileName(
    fileName,
    screenExpTemplateData: ScreenExperimentTemplateDTO,
  ) {
    ///make these apis authentication
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    const saveScreenExpTemplate = new SaveScreenExpTemplateDTO();
    saveScreenExpTemplate.screenExperimentTemplate = screenExpTemplateData;
    saveScreenExpTemplate.fileName = fileName;
    return await expWizTemplate.saveScreenExperimentTemplateData(saveScreenExpTemplate);
  }

  async createExperiment(expInfo: ExperimentInfo, treeNodeId: number) {
    const expWizTemplate: ScreenExpWizardClient = ModelFactory(ScreenExpWizardClient);
    const expDTO = new SaveNonPersistedExpDTO();
    expDTO.experimentInfo = expInfo;
    expDTO.paretnTreeNodeId = treeNodeId;
    return await expWizTemplate.createExperiment(expDTO);
  }

  async saveWizardExperiment(
    expDto: ExperimentDTO,
    expInfo: ExperimentInfo,
    treeNodeid,
    layers?: LayerDTO[],
    isoScores?: ISOWellDropScoreDTO[],
    plateTypeId?: number,
    existingExperimentId?: number,
  ) {
    const expWizTemplate: ExperimentClient = ModelFactory(ExperimentClient);
    const saveWizardExp = new SaveNonPersistedExpDTO();
    saveWizardExp.paretnTreeNodeId = treeNodeid;
    saveWizardExp.experimentInfo = expInfo;
    saveWizardExp.expDto = expDto;
    saveWizardExp.layers = layers;
    saveWizardExp.isoScores = isoScores;
    saveWizardExp.plateTypeId = plateTypeId;
    saveWizardExp.existingExperimentId = existingExperimentId;
    return await expWizTemplate.saveWizardExperiment(saveWizardExp);
  }
}
